import React, { useMemo } from 'react';
import classNames from 'classnames';

type Props = {
  children: React.ReactNode;
  className?: string;
};
export const H1: React.FC<Props> = ({ children, className }) => {
  const dynamicClasses = useMemo(() => {
    return classNames(
      'mb-6 md:mb-8 text-center font-bold text-[1.5rem] leading-[2.125rem] text-text-primary md:text-[2rem] md:leading-[2.375rem]',
      {
        [`${className}`]: !!className,
      }
    );
  }, [className]);

  return <h1 className={dynamicClasses}>{children}</h1>;
};
